import React from "react";
import CommonModal from "../../components/Modal";
import { ModalProps } from "../../components/Modal/Modal.types";
import { useTranslation } from "react-i18next";

const CampaignErrorModal: React.FC<ModalProps> = ({
    open,
    onClose,
    onConfirm,
}) => {
    const { t } = useTranslation();

    return (
        <CommonModal
            visible={open}
            confirmText={t("phishingManager.campaignErrorModal.confirmText")}
            cancelText={t("phishingManager.campaignErrorModal.cancelText")}
            background="#FBEAEA"
            iconType={"campaignError"}
            modalContentTitle={t("phishingManager.campaignErrorModal.title")}
            modalContentDesc={[
                t("phishingManager.campaignErrorModal.description.line1"),
                t("phishingManager.campaignErrorModal.description.line2"),
                t("phishingManager.campaignErrorModal.description.line3")
            ]}
            onClose={onClose}
            onConfirm={onConfirm}
        />
    );
};

export default CampaignErrorModal;